import { Directive, ElementRef, EventEmitter, HostListener, Input, NgZone, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[column-resizer]'
})
export class ColumnResizerDirective implements OnInit, OnDestroy {
  // 只支持初始值，不支持中间变更
  @Input('column-resizer') enableDrag = true;
  @Input() columnIndex = -1;
  // 拖拽条
  private resizeBar: HTMLElement;
  // 拖拽条的鼠标按下事件监听
  resizerMouseDownListener: any;
  private isDragging = false;
  private destroyListeners: () => void;
  parentWidth: any;
  @Output() resizeStart = new EventEmitter<any>();
  @Output() resizeMove = new EventEmitter<any>();
  @Output() resizeEnd = new EventEmitter<any>();

  constructor(private el: ElementRef, private renderer: Renderer2, public ngzone: NgZone) { }

  ngOnInit() {
    if (this.enableDrag) {
      // 如果启用
      this.resizeBar = this.renderer.createElement('span');
      this.renderer.addClass(this.resizeBar, 'column-resize-bar');
      this.renderer.appendChild(this.el.nativeElement, this.resizeBar);

      this.ngzone.runOutsideAngular(() => {
        const mouseUp$ = fromEvent(this.resizeBar, 'mouseup');
        this.resizerMouseDownListener = fromEvent(this.resizeBar, 'mousedown').pipe(
          takeUntil(mouseUp$)
        ).subscribe((e: any) =>
          this.onMouseDown(e)
        );
      });
    }
  }
  /**
   * 拖拽条——鼠标按下事件
   * @param event 
   */
  onMouseDown(event: MouseEvent) {
    // 增加当前拖拽的样式
    this.renderer.addClass(this.el.nativeElement, 'column-resizeing');
    this.startDragging(event);
    this.resizeStart.emit(event);
  }

  private getColumnWidth(node: HTMLElement): number {
    return node.getBoundingClientRect().width;
  }

  private startDragging(event: MouseEvent) {
    this.isDragging = true;
    const parentNode = this.el.nativeElement.parentNode;
    this.parentWidth = this.getColumnWidth(parentNode);

    const mouseMoveListener = this.renderer.listen(document, 'mousemove', (e) => this.onMouseMove(e));
    const mouseUpListener = this.renderer.listen(document, 'mouseup', (e) => this.stopDragging(e));
    const mouseLeaveListener = this.renderer.listen(document, 'mouseleave', (e) => this.stopDragging(e));

    this.destroyListeners = () => {
      mouseMoveListener();
      mouseUpListener();
      mouseLeaveListener();
    };

    event.preventDefault();
  }

  private onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    this.resizeMove.emit({ event: event, index: this.columnIndex });
  }

  private stopDragging(event: MouseEvent | null) {
    this.isDragging = false;
    if (this.destroyListeners) {
      this.destroyListeners();
    }
    this.renderer.removeClass(this.el.nativeElement, 'column-resizeing');
    if (event) {
      this.resizeEnd.emit({ event: event, index: this.columnIndex });
    }
  }

  ngOnDestroy() {
    if (this.resizeBar) {
      this.renderer.removeChild(this.el.nativeElement, this.resizeBar);
    }
    this.stopDragging(null);
  }
}
